<section class="core-values">
    <div class="section-name">
        <h6>CODE OF ETHICS & BUSINESS CONDUCT</h6>
        <div class="line"></div>
    </div>
<div class="core-values-wrapper">
    <div class="introduction">
        <h3>Introduction</h3>
        <p>WorldERP’s Code of Ethics and Business Conduct is structured by core business values that are essential to the success of our company and the foundation of all that we do. </p>
    </div>
    <div (click)="clickValueItem($event)" class="core-values-items">
        <div class="row">
            <div class="col-lg-3 col-sm-12 value-item">
                <div class="value-item-img-wrapper">
                    <img class="value-item-img" src="../../../assets/about/core_values/1computer-screen.png" alt="Protect anonymity">
                </div>
                <h5 class="value-item-title">Protect anonymity and confidentiality.</h5>
                <div class="value-item-text">We are committed to informing our customers of what data is being collected and how it will be used and allowing the customer to refuse or revoke consent at any time.</div>
            </div>

            <div class="col-lg-3 col-sm-12 value-item">
                <div class="value-item-img-wrapper">
                    <img class="value-item-img" src="../../../assets/about/core_values/2neutral.png" alt="Remain neutral">
                </div>
                <h5 class="value-item-title">Remain neutral by removing bias and judgement.</h5>
                <div class="value-item-text">When conducting research, analysis, or engaging in conversation, we will try our best to remove environmental, study, personal, and social biases, while also striving to be credible and honest. Some examples of everyday biases include:
                    <ul>
                        <li>Environmental bias: “The setup of hospital room we are in is different than the hospital room where the nurse normally works.”</li>
                        <li>Study bias: “Having an observer in the room may change the way a user performs these tasks.”</li>
                        <li>Personal bias: “I don’t like the color orange.”</li>
                        <li>Social bias: “Teenagers are bad drivers” or “All researchers are introverts.”</li>
                    </ul>
                </div>
            </div>

            <div class="col-lg-3 col-sm-12 value-item">
                <div class="value-item-img-wrapper">
                    <img class="value-item-img" src="../../../assets/about/core_values/3integration.png" alt="integrity">
                </div>
                <h5 class="value-item-title">Achieve the highest level of integrity possible.  </h5>
                <div class="value-item-text">We are committed to honesty and choosing a path of integrity in all business transactions and dealings with others.</div>

            </div>

            <div class="col-lg-3 col-sm-12 value-item">
                <div class="value-item-img-wrapper">
                    <img class="value-item-img" src="../../../assets/about/core_values/ethically.png" alt="Act ethically">
                </div>
                <h5 class="value-item-title">Act ethically in every interaction and business transaction.</h5>
                <div class="value-item-text">Implementing appropriate business policies and practices with regard to arguably controversial subjects.</div>

            </div>
        </div>

        <div class="row">
            <div class="col-lg-3 col-sm-12 value-item">
                <div class="value-item-img-wrapper">
                    <img class="value-item-img" src="../../../assets/about/core_values/compliance.png" alt="Compliance">
                </div>
                <h5 class="value-item-title">Compliance.</h5>
                <div class="value-item-text">We comply with all laws, regulations, and WorldERP policies that govern our business and employees’ actions on behalf of the company.</div>

            </div>

            <div class="col-lg-3 col-sm-12 value-item">
                <div class="value-item-img-wrapper">
                    <img class="value-item-img" src="../../../assets/about/core_values/respect.png" alt="Respect all">
                </div>
                <h5 class="value-item-title">Respect all living things.</h5>
                <div class="value-item-text">Strive to the best of our abilities to protect nature, the environment and all living things in everything we do.</div>

            </div>

            <div class="col-lg-3 col-sm-12 value-item">
                <div class="value-item-img-wrapper">
                    <img class="value-item-img" src="../../../assets/about/core_values/golden_rule.png" alt="Golden Rule">
                </div>
                <h5 class="value-item-title">Abide by the Golden Rule.</h5>
                <div class="value-item-text">“Do unto others as you would have them do unto you.” (Matt. 7:12)</div>

            </div>

            <div class="col-lg-3 col-sm-12 value-item">
                <div class="value-item-img-wrapper">
                    <img class="value-item-img" src="../../../assets/about/core_values/honorable.png" alt="Be Honorable">
                </div>
                <h5 class="value-item-title">Be Honorable.</h5>
                <div class="value-item-text">Whether conducting business or engaging in conversation it is important that we be honest, fair, and worthy of respect.</div>

            </div>
        </div>

        <div class="row">
            <div class="col-lg-3 col-sm-12 value-item">
                <div class="value-item-img-wrapper">
                    <img class="value-item-img" src="../../../assets/about/core_values/do_your_best.png" alt="Do your best">
                </div>
                <h5 class="value-item-title">Do your best.</h5>
                <div class="value-item-text">We must incorporate excellence and quality in our work in everything we do, the first time and every time and then strive to continuously improve. </div>

            </div>

            <div class="col-lg-3 col-sm-12 value-item">
                <div class="value-item-img-wrapper">
                    <img class="value-item-img" src="../../../assets/about/core_values/teamwork.png" alt="Teamwork">
                </div>
                <h5 class="value-item-title">Teamwork.</h5>
                <div class="value-item-text">We must work together as a team to benefit WorldERP and our customers.</div>

           </div>

            <div class="col-lg-3 col-sm-12 value-item">
                <div class="value-item-img-wrapper">
                    <img class="value-item-img" src="../../../assets/about/core_values/communication.png" alt="Communication">
                </div>
                <h5 class="value-item-title">Communication.</h5>
                <div class="value-item-text">We must share information effectively with each other, but also know how to protect the confidentiality of our information and our customer’s information.</div>

            </div>

            <div class="col-lg-3 col-sm-12 value-item">
                <div class="value-item-img-wrapper">
                    <img class="value-item-img" src="../../../assets/about/core_values/customesr_satis.png" alt="Customer Satisfaction">
                </div>
                <h5 class="value-item-title">Customer Satisfaction.</h5>
                <div class="value-item-text">We must treat customer satisfaction as a top priority.</div>

            </div>
        </div>

        <div class="row">
            <div class="col-lg-3 col-sm-12 value-item">
                <div class="value-item-img-wrapper">
                    <img class="value-item-img" src="../../../assets/about/core_values/insight.png" alt="Report all insights">
                </div>
                <h5 class="value-item-title">Report all insights and limitations.</h5>
                <div class="value-item-text">We should never hide relevant information or mislead our customers. Share all positive and negative information in a humble, respectful way. This can be uncomfortable, but it’s our duty to report the truth.  Additionally, state limitations and assumptions made, so as not to misrepresent the information you are giving.</div>

            </div>

        </div>

    </div>
</div>
</section>
